/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { NbGlobalPhysicalPosition, NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService, NbToastrService } from '@nebular/theme';

import { LayoutService } from '../../../@core/utils';
import { filter, map, takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { UserStore } from '../../../@core/stores/user.store';
import { Tenant, TenantData } from '../../../@core/interfaces/masters/tenant';
import { environment } from '../../../../environments/environment';


import { UserData, User } from './../../../@core/interfaces/common/users';
import { NgZone } from '@angular/core';
import { Message } from '../../../@core/interfaces/patient-services/message';
import { ChatService } from '../../../@core/backend/common/services/VideoChat.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AnyARecord } from 'dns';
import { AllowIn, ShortcutEventOutput, ShortcutInput } from 'ng-keyboard-shortcuts';
import { Location } from '@angular/common';
import { PatientRegistrationData } from '../../../@core/interfaces/patient-services/patient-registration';
import { imageatch_detData } from '../../../@core/interfaces/masters/imageatch_det';
import { PhysicianData } from '../../../@core/interfaces/masters/physician-mst';
import { CookieService } from '../common/service/cookies.service';
import { BloodBankModuleData } from '../../../pages/blood-bank/backend/interface/blood-bank';
import { DateService } from '../common/service/date.service';
import { PatientAppointmentData } from '../../../@core/interfaces/patient-services/patient-appointment';
import { CountryService } from '../../../_services/patient-portal-country.service';
import { JobCategoryData } from '../../../@core/interfaces/masters/jobCategory';
import { SharedService } from '../../../@core/interfaces/masters/SharedService';
import { DeviceIntegrationService } from '../../../_services/device-integration.service';
import { DeviceNotification, DeviceNotificationService } from '../../../_services/device-notification.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss','../../../../assets/css/nurse.css'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
protected readonly unsubscribe$ = new Subject<void>();
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  tenantDetail:Tenant;
  tenantName:any;
  selectIcon="location_on";
  Selecttext="Select Location";
  selectedLocation: any;
  ischangeBranch: boolean = false;
  onChangeBranchData: any;
  isquicksearch: boolean = false;
  patientData:any=[];
  public renewalDate=localStorage.getItem("renewalDate");
  public isSuperUser=localStorage.getItem("isSuperUser");
  public customerType=localStorage.getItem("customerType");
  showPatPortHeader: boolean = false;
  //openBookingPopUp:boolean=false;
  public regID=localStorage.getItem("regID");
  countryCodeDropDownLists: Array<any>= [];
  countryDetail: any={};     
  isVOPD: boolean = localStorage.getItem('tenantType') === 'VOPD';
  isSuperAdmin: boolean=false;
  currentLocation: string='';
  jobCategory=localStorage.getItem('jobCategoryId');
  userFlag=localStorage.getItem("userFlag");
  isEmergency:string = '';
  jobCategoryData:Array<any>= [];
  filterCategory: string[] = Array.from(
  new Set(((localStorage.getItem("DashboardCounter") || "") + "," + this.jobCategory)?.split(",")?.filter(x => x.trim() !== "")));


  callBranch(x: any): void {
    this.ischangeBranch = true;
    this.onChangeBranchData = x;  
    localStorage.removeItem("TenantHospitalImg")
    // this.selectedLocation = x;
    // this.Selecttext = this.allValue?.find(e=>e.id == localStorage.getItem("branchId")).area;

  }
  selectValue(val){
    // Branch-wise renewal: a branch past its renewal date cannot be used (login checks it too). The reminder banner then shows the
    // renewal date of the branch switched to.
    this.tenantSrvc.getById(`${this.apiUrl}/tenants/${this.tenantId}/branchrenewal/access/${val.id}`).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (access: any) => {
        if (access && access.allowed === false) {
          this.dialogNo();                                                    // stay on the current branch
          this.branchToast(access.message || 'The subscription of this branch has expired. Please contact Ezovion to renew it.');
          return;
        }
        const renewal = access?.renewalDate ? new Date(access.renewalDate) : null;
        if (renewal && !isNaN(renewal.getTime())) { localStorage.setItem("renewalDate", renewal.toDateString()); }
        this.switchBranch(val);
      },
      () => {
        this.dialogNo();
        this.branchToast('The branch could not be checked. Please try again.');
      });
  }

  /** The same red toast the HMS pages use for errors. */
  private branchToast(message: string) {
    this.toastr.danger(message, 'Branch', {
      position: NbGlobalPhysicalPosition.BOTTOM_RIGHT,
      duration: 5000, hasIcon: true, destroyByClick: true, preventDuplicates: true,
    });
  }

  private switchBranch(val){
    this.Selecttext=val.area;
    localStorage.setItem("branchId",val.id);
    this.router.navigateByUrl("pages/patientservices/app").then(() => {
      window.location.reload();
    });
    this.ischangeBranch = false;
  }
  dialogNo() {
    this.selectedLocation=localStorage.getItem("branchId");
    this.Selecttext = this.allValue?.find(e=>e.id == localStorage.getItem("branchId")).area;
    this.ischangeBranch = false;
  }
  dialogOk() {
    this.selectValue(this.onChangeBranchData);
  }

private tenantId = localStorage.getItem("tenantId");
private branchId = localStorage.getItem("branchId");
private physicianId = localStorage.getItem("physicianId");

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = this.getMenuItems();

  msg_count:number=0;
  private tenandId = localStorage.getItem("tenantId");
  private suserId = localStorage.getItem("userId");
  private userId:number=0;
  userName = '';
  txtMessage: string = '';
  uniqueID: string = new Date().getTime().toString();
  messages = new Array<Message>();
  message_ = new Message();
  labsrcname :any;
  _messages:any[]=[];
  data:any;
  flipped:boolean=false;
  uName:any;
  allValue: any = [];
  users: { name: string, title: string, id: string }[] = [];
  all_massages:any=[];
  
  shortcuts: ShortcutInput[] = [];
  selectedCountryCode: string = '';
  isregionSelected: boolean = false;
  activeMenu:string;
  activeMenuLab:string='Dashboard';
  srcname = "/assets/images/hospitalimg.jpeg";
  searchWord: any = '';
  lnuserName = '';//"Dr.Ram Kumar";
  lnDeptName = null;//"General Doctor";
  closeAppointmentPopUp:boolean=false;
  restrictedPatientAppointments:string;
  departmentId:string;
  isDocLogIn:boolean=false;
  isSaudiBranch: boolean = false;
  private headerHeightObserver: any;
  constructor(private elementRef: ElementRef<HTMLElement>,
      private sidebarService: NbSidebarService,
     protected categorySrvc: JobCategoryData,
      private menuService: NbMenuService,
      private themeService: NbThemeService,
      private userStore: UserStore,
      private tenantSrvc:TenantData,
      private layoutService: LayoutService,
      private breakpointService: NbMediaBreakpointsService,
      protected userService: UserData,protected dateService: DateService,
      public chatService: ChatService,
      private location:Location,  private route: ActivatedRoute,
      protected patRegSrvc: PatientRegistrationData,
      private iatchSrvc: imageatch_detData, protected phySrvc: PhysicianData ,private logOutService: BloodBankModuleData,
      private _ngZone: NgZone,protected router: Router, private logoupdate:CookieService, private patAptSrv: PatientAppointmentData, private countryService: CountryService,
    private sharedService: SharedService, private readonly deviceFleet: DeviceIntegrationService, private toastr: NbToastrService,
    private readonly deviceNotifications: DeviceNotificationService)
     {
          this.route.params.subscribe(params => {
            this.searchWord = !!params['searchWord']?params['searchWord']:''; 
          });
    if(this.router.url.includes("/patient-portal/")){
      this.showPatPortHeader=true;
    }
    else{
      this.showPatPortHeader=false;
    }

          this.logoupdate.logoUpdate$.pipe(filter(res => !!res)).subscribe(logo => {
            this.srcname=logo
          });

          this.route.queryParams.pipe(takeUntil(this.unsubscribe$)).subscribe(params => {
            this.restrictedPatientAppointments=params['restrictedPatientAppointments'];
            this.departmentId=params['deptId'];
            this.isDocLogIn=params['isDocLogIn'];})

          this.menuService.onItemClick()
            .pipe(takeUntil(this.destroy$))
            .subscribe(event => {
              if (event.item.data?.action === 'header-logout') {
                this.logOutUser();
              }
            });
      }

  // Job-category menus/behaviour exist only for the NEW casesheet; OLD logins get the normal employee menu.
  // Read from storage each time so it is correct right after login.
  get isNewCasesheet(): boolean {
    return localStorage.getItem('casesheetVersion') === 'NEW';
  }

  getMenuItems() {
    const userLink = this.user ?  '/pages/users/current-user/'+this.user.id : '';
    return [
      { title: 'Profile', link: userLink},
      { title: 'Logout', data: { action: 'header-logout' } },
    ];
  }

  ngOnInit() {
    this.isSaudiBranch = localStorage.getItem('LoginCountryCode') === '+966' ? true : false;
    this.activeMenu=localStorage.getItem('activeMenu') ||'Dashboard';
    this.currentTheme = this.themeService.currentTheme;
    this.allValue.length = 0; 
    this.allValue = JSON.parse(localStorage.getItem("branchAccessList"));
    this.Selecttext = this.allValue?.find(e=>e.id == localStorage.getItem("branchId")).area;
    this.user = this.userStore.getUser();
    this.selectedLocation =localStorage.getItem("branchId");
    // this.Selecttext = this.allValue?.find(e=>e.id == localStorage.getItem("branchId")).area;
   this.tenantId =this.user.tenantId;
   this.loadTenantName(); 
   this.loadCountryMaster()
    this.userMenu = this.getMenuItems();

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

      this.loadImage();
      if(this.physicianId != "0")
      this.getPhysician();
      else
        this.lnuserName = this.user?.userName;
    const countryData = !!localStorage.getItem('LoginCountryDet') ? JSON.parse(localStorage.getItem('LoginCountryDet') || '{}') : null;
    this.currentLocation = countryData?.country || '';
    this.isSuperAdmin = localStorage.getItem('ezovionAdmin') === "true";

    if(this.filterCategory?.length > 0){this.fetchJobCategory();}
      this.sharedService.getHeaderMenuUpdate.subscribe(res => {
      if (res) {
        this.activeMenu = res;
      }
    });
    
   }
  

getPhysician()
{
  this.phySrvc.getById(`${this.apiUrl}/physicians/${this.tenantId}/${this.branchId}/${this.physicianId}/GetPhyscianById`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    
    this.lnuserName =data?.displayName;
    this.lnDeptName=data?.department?.name
    const isEmergencyVal = data?.isEmergency ? 'true' : 'false';
    this.isEmergency = isEmergencyVal;

  }, (error) => {
  }, () => {
  });
}
  get apiUrl(): string {
    return environment.apiUrl;
  }
loadTenantName(){
  this.tenantSrvc.getById(`${this.apiUrl}/tenants/${this.tenantId}/tenantmst/${this.tenantId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    this.tenantDetail=data;
    this.tenantName=this.tenantDetail.name;
  });
}

renewalDateExpiryMessage():boolean{
  // The renewal date of the signed-in branch (set at login / branch switch); without a valid one there is no banner.
  if (!this.renewalDate || isNaN(new Date(this.renewalDate).getTime())) { return false; }
  let date = new Date(this.renewalDate);
    var date1:any = new Date(date);
    var date2:any = new Date();
    let days = Math.floor((date1.getTime() - date2.getTime()) / 1000 / 60 / 60 / 24);
  if(days<=30){return true;}else{return false;}
}

loadCountryMaster(): void {
  this.patAptSrv.list(`countries/getCountryMasterAnonymous`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.countryCodeDropDownLists = data.details;
      
    }, (error) => {
      if(error.status==401){
        this.router.navigateByUrl('/auth/patient-portal');
      }
    }, () => {
    if(this.countryCodeDropDownLists.length > 0){
      const storedCountryCode = localStorage.getItem('countryCode');
      this.selectedCountryCode = this.countryCodeDropDownLists.find(x => x.countryCode == storedCountryCode)?.id;
    }
  });
}

  onSelectCountryCode(event: any) {
    if(event){
      this.isregionSelected = true;
      this.selectedCountryCode = event[0]?.data?.id;
      localStorage.setItem('countryCode', event[0]?.data?.countryCode);
      this.countryService.setCountryCode(event[0]?.data?.countryCode);
    } 
  }

loadImage(){
    //
    if(localStorage.getItem("TenantHospitalImg")==null){
      this.iatchSrvc.getById(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/all`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        
        var x =  data.filter(x=>x.phyId==null&&x.empId==null&&x.patId==null&&x.tenantId===this.tenantId && x.category=="logo")
        var lablogo = data.filter(x => x.phyId == null && x.empId == null && x.patId == null && x.tenantId === this.tenantId && x.category == "Lab logo")
        if(x.length>0)
        {
          x[0].isCreate = true;
          x[0].isEdit = true;
          this.iatchSrvc.create(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/download`,x[0]).pipe(takeUntil(this.unsubscribe$)).subscribe((downloaddata: any) => {
          this.srcname = 'data:image/jpeg;base64,' + downloaddata;
          localStorage.setItem("TenantHospitalImg", this.srcname);
        }, (error) => {

        }, () => {

        });
      }
       if (lablogo.length > 0) {
        lablogo[0].isCreate = true;
        lablogo[0].isEdit = true;
        this.iatchSrvc.create(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/download`, lablogo[0]).pipe(takeUntil(this.unsubscribe$)).subscribe((downloaddata: any) => {
          this.labsrcname = 'data:image/jpeg;base64,' + downloaddata;
          localStorage.setItem("Lab logo", this.labsrcname);
        }, (error) => {

        }, () => {

        });
      }  
    }, (error) => {

    }, () => {

    });
  }else{
    this.srcname = localStorage.getItem("TenantHospitalImg");
  }
}
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.headerHeightObserver?.disconnect();
  }

  private updateHeaderHeightVar() {
    const headerEl = this.elementRef.nativeElement.closest('nb-layout-header') as HTMLElement || this.elementRef.nativeElement;
    const height = headerEl.offsetHeight;
    if (height > 0) {
      document.documentElement.style.setProperty('--app-header-height', `${height}px`);
    }
  }

  changeTheme(themeName: string) {
    this.userStore.setSetting(themeName)
      .pipe(takeUntil(this.destroy$))
      .subscribe();

    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  // Device Integration lives as a header quick-access button rather than a
  // sidebar menu entry (see pages-menu.ts) -- same pill-button + badge UI as
  // the OPD app's topbar, backed by the same fleet state the Device
  // Integration page itself edits (DeviceIntegrationService is a root
  // singleton, so this always reflects the page's live connection state).
  get connectedDeviceCount(): number { return this.deviceFleet.connectedCount; }
  get totalDeviceCount(): number { return this.deviceFleet.totalCount; }
  get deviceIntegrationReady(): boolean { return this.deviceFleet.allMandatoryConnected; }

  openDeviceIntegration(): void {
    this.router.navigateByUrl('/pages/device-integration');
  }

  // Notification bell -- lists device-disconnect notifications raised by
  // DeviceIntegrationService (via DeviceNotificationService) until the user
  // reads one, at which point it's dismissed and drops out of both the list
  // and the unread badge count.
  showNotificationPanel = false;
  readonly notifications$: Observable<DeviceNotification[]> = this.deviceNotifications.notifications$;
  readonly unreadNotificationCount$: Observable<number> = this.deviceNotifications.unreadCount$;

  // Panel chrome (title/empty-state/tooltip) tracks the same language the
  // disconnect messages themselves are worded in -- see device-notification.service.ts.
  get notificationPanelTitle(): string { return this.deviceNotifications.bilingual('panelTitle'); }
  get notificationEmptyText(): string { return this.deviceNotifications.bilingual('emptyState'); }
  get notificationMarkAsReadTitle(): string { return this.deviceNotifications.bilingual('markAsRead'); }

  toggleNotificationPanel(): void {
    this.showNotificationPanel = !this.showNotificationPanel;
  }

  dismissNotification(id: string): void {
    this.deviceNotifications.dismiss(id);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.showNotificationPanel) return;
    const wrapper = this.elementRef.nativeElement.querySelector('.notification-wrapper');
    if (wrapper && !wrapper.contains(event.target as Node)) {
      this.showNotificationPanel = false;
    }
  }

 

  logOutUser(){
    
    let postData={
      sessionId:localStorage.getItem("sessionId"),
      tenantId:localStorage.getItem("tenantId"),
      branchId:localStorage.getItem("branchId"),
      LogOutType:"User"
    }
    this.logOutService.searchList("auth/sign-out-webApp",postData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    }, (error) => {
    }, () => {
      
      this.router.navigateByUrl("/auth/login");
      var loggedTenantUserId=localStorage.getItem("tenantUserId");
      var loggedCustomerName=localStorage.getItem("customerName");
      var reponseTenantId=localStorage.getItem("tenantId");
      var currentUserMobileNumber=localStorage.getItem("currentUserMobileNumber");

      let userId = localStorage.getItem("wardUserId");
      let priceList = localStorage.getItem("wardWisePrice");
      localStorage.clear();
      localStorage.setItem("wardWisePrice", priceList);
      localStorage.setItem("wardUserId", userId);
    //  localStorage.setItem("skipValidTenant","false");
      localStorage.setItem("tenantUserId",loggedTenantUserId);
      localStorage.setItem('customerName',loggedCustomerName);
      localStorage.setItem('responseTenantId',reponseTenantId)
      localStorage.setItem("currentUserMobileNumber",currentUserMobileNumber);

    });
  }
  openForm() {
    document.getElementById("myForm").style.display = "block";
  }

  closeForm() {
    document.getElementById("myForm").style.display = "none";
  }


  sendMessage(event: any, userName: string, avatar: string, reply: boolean) {
    const files = !event.files ? [] : event.files.map((file) => {
      return {
        url: file.src,
        type: file.type,
        icon: 'file-text-outline',
      };
    });

    this._messages.push({
      text: event.message,
      date: new Date(),
      reply: reply,
      type: files.length ? 'file' : 'text',
      files: files,
      user: {
        name: this.uName,
        avatar: '../.././../../assets/images/userav.png',
      },
    });

      this.message_ = new Message();
      this.message_.clientuniqueid = this.uniqueID;
      this.message_.type = "sent";
      this.message_.message = event.message;// this.txtMessage;
      this.message_.date = new Date();
      this.message_.userId=this.userId+","+this.suserId;//.toString();
      this.message_.tenantId=this.tenandId;
      this.message_.userName=this.uName;
      this.message_.chatType='';
      this.messages.push(this.message_);
      var data=this.all_massages;
      if(this.all_massages.length==0){
        this.all_massages.push({'id':this.userId,'message':this._messages});
      }else{
        var ii;
        var data;
        for(var i=0;i<this.all_massages.length;i++){
          if(this.all_massages[i].id==this.userId) {
            ii=i;
            data=this.all_massages[i].message
          }
         }
        var data=this.all_massages.filter(e => e.id === this.userId);
            if(data.length==0){
              this.all_massages.push({'id':this.userId,'message':this._messages});
            }else{
               if(ii!=null) {
                 var data_=this._messages;
                this.all_massages[ii].message=data_;
                var data1=this.all_massages[ii].message;
                this._messages=data1;
               }
            }
     }
     this.setMessages(this.all_massages);
      this.txtMessage = '';


  }

  toggleView() { this.flipped = !this.flipped; }

  chatUser(user){
    this.msg_count=0;
    this._messages=[];
    this.userName=user.name;
    this.userId=user.id;
    this.toggleView();
    for (var i=0;i<this.all_massages.length;i++) {
          if(this.all_massages[i].id==user.id){
            this.mesage_set(user.id,0)
            var data=this.all_massages[i].message;
            this._messages=data;
          }
        }
  }
  sendMessage1(): void {
    if (this.txtMessage) {
      this.message_ = new Message();
      this.message_.clientuniqueid = this.uniqueID;
      this.message_.type = "sent";
      this.message_.message = this.txtMessage;
      this.message_.date = new Date();
      this.messages.push(this.message_);
      this.txtMessage = '';
    }
  }
  private subscribeToEvents(): void {
    
  }

  reorderUserlist(userId){

    var users=[];
    for(var i=0;i<this.users.length;i++){
      if(userId==this.users[i].id) {
        users.push(this.users[i]);
      }
    }

    for(var j=0;j<this.users.length;j++){
      if(userId!=this.users[j].id) {
        users.push(this.users[j]);
      }
    }
    this.users=users;
  }

  setMessages(data:any){
    window.localStorage.setItem("msg",JSON.stringify(data));
  }
  getMessages(){
    return JSON.parse(window.localStorage.getItem("msg"));
  }
  getUser(id){
    var data=this.users.filter(e => e.id === id);
    return data[0];
  }

  fetchUsertype() {
    if(this.getMessages()!=null){
      this.all_massages=this.getMessages();
    }

    this.users=[];
    this.userService.userList(`users/userlist/${this.tenandId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((datas: any) => {
      this.data = datas;
      for(var i=0;i<datas.length;i++){
        if(parseInt(this.suserId)===datas[i].id){
          this.userName=datas[i].firstName+" "+datas[i].lastName;
          this.uName=this.userName;
	        this.userId=datas[i].id;
        }else{
          this.users.push({name: datas[i].firstName+" "+datas[i].lastName, title: '0', id: datas[i].id})
        }
      }

    }, (error) => {

    }, () => {

    });
  }

  mesage_set(id,count){
    for(var i=0;i<this.users.length;i++){
      if(this.users[i].id==id){
          this.users[i].title=count;
      }
    }
  }
  ngAfterViewInit(): void {
    this.shortcuts.push(
      {
        key: "shift + b",
        preventDefault: true,
        allowIn: [AllowIn.Textarea, AllowIn.Input],
        command: (output: ShortcutEventOutput) => this.location.back() ,
      },   
      {
        key: "shift + f",
        preventDefault: true,
        allowIn: [AllowIn.Textarea, AllowIn.Input],
        command: (output: ShortcutEventOutput) => this.location.forward() ,
      },
    );

    this.updateHeaderHeightVar();
    const ResizeObserverCtor = (window as any).ResizeObserver;
    const headerEl = this.elementRef.nativeElement.closest('nb-layout-header') || this.elementRef.nativeElement;
    if (ResizeObserverCtor) {
      this.headerHeightObserver = new ResizeObserverCtor(() => this.updateHeaderHeightVar());
      this.headerHeightObserver.observe(headerEl);
    } else {
      window.addEventListener('resize', () => this.updateHeaderHeightVar());
    }
  }

  callPages(pageName){
      let route=this.jobCategory=='25' ? `/pages/nurse/nurse-manager-dashboard` :
       this.isSaudiBranch && pageName === 'Dashboard' ? localStorage.getItem('landingPageUrl') :
       this.jobCategory=='2' ? `/pages/nurse/nurse-dashboard` :
       this.jobCategory=='26' ? `/pages/ehr/cathlab` :
       this.jobCategory=='27' ? `/pages/physiotheraphy/physiotherapy` :
       this.jobCategory=='28' ? `/pages/ehr/dialysis` :
       this.jobCategory=='29' ? `/pages/ehr/endoscopy` :
       this.jobCategory=='30' ? `/pages/dental/dental-dashboard` :
        this.jobCategory=='31' ? `/pages/cssd/cssd-dashboard` :
        this.jobCategory=='32' ? `/pages/ehr/mortury` :
        this.jobCategory=='33' ? `/pages/ot/operation-theater` :
        this.jobCategory=='34' ? `/pages/ehr/oncology` :
        this.jobCategory=='35' ? `/pages/crm/crm-dashboard` :
        this.jobCategory=='36' ? `/pages/masters/accounts-dashboard/reports/daybook` :
        this.jobCategory=='7' ? `/pages/diet/diet-dashboard` :
        this.jobCategory=='38' ? `/pages/ehr/laundry` :
        this.jobCategory=='37' ? `/pages/biomedical/biomedical-dashboard` :
        this.jobCategory=='39' ? `/pages/kitchen/dashboard` :
        this.userFlag=='Physician' && this.isEmergency=='true' && pageName=='Dashboard' ? `pages/emergency/er-doctor-workstation` :
        this.jobCategory=='43' && pageName=='Dashboard' ? `pages/emergency/er-nurse-workstation` :
        this.jobCategory=='44' && pageName=='Dashboard' ? `pages/emergency/er-referral-doctor` :
        this.jobCategory=='45' && pageName=='Dashboard' ? `/pages/emergency/er-module-reception` :
        this.jobCategory=='46' && pageName=='Dashboard' ? `/pages/emergency/er-module-reception` :
        this.jobCategory=='47' && pageName=='Dashboard' ? `/pages/emergency/er-module-reception` :


        // dashboard
        pageName=='Dashboard' ? `/pages/insurance/billing-office-dashboard` :
        //ER
        pageName == 'ER Registration' ? `/pages/emergency/emergency-registration` :
        pageName == 'ER Patient Queue' ? `/pages/emergency/emergency-new-list` :
        pageName == 'Bed Management' ? `/pages/emergency/bed-board` :
        pageName == 'My WorkList' ? `/pages/emergency/emergency-new-list` :
	pageName == 'Nurse WorkList' ? `/pages/emergency/nurse-work-list` :
        pageName == 'IP Admission Request' ? `/pages/emergency/ip-admission-request-list` :
        pageName == 'Referral Request' ? `/pages/masters/referral-queue/Appointment` :
        pageName == 'Pending Bill List' ? `/pages/patientservices/pending-bill-list` :
        pageName == 'OP Bill List' ? `/pages/patientservices/bill-list/0` :
        //  admin
        pageName=='Beneficiary List' ? `/pages/insurance/nphies-beneficiary-discovery-list` :
        pageName=='Eligibility List' ? `/pages/insurance/nphies-coverage-eligibility-transactions` :
        // pre auth
        pageName=='Pre-auth Ready To Sent' ? `/pages/insurance/nphies-approval-dashboard/submitauthorization` :   // submitted list 
        pageName=='Pre-auth Submitted List' ? `/pages/insurance/nphies-approval-dashboard/authorization-all` :   // submitted list 
        pageName=='Pre-auth Approved List' ? `/pages/insurance/nphies-approval-dashboard/authorization-approved` : // approved list
        pageName=='Pre-auth Rejected List' ? `/pages/insurance/nphies-approval-dashboard/authorization-rejected` : // rejected list
        pageName=='Pre-auth Partial List' ? `/pages/insurance/nphies-approval-dashboard/authorization-partial` : // parcial approved list
        pageName=='Pre-auth Pended List' ? `/pages/insurance/nphies-approval-dashboard/authorization-pended` : // pending list
        pageName=='Pre-auth Error List' ? `/pages/insurance/nphies-approval-dashboard/authorization-error` : //error list
        // approvel
        // pageName=='Approval Pending List' ? `/pages/insurance/nphies-approval-dashboard` :
        // pageName=='Approval Approved List' ? `/pages/insurance/nphies-approval-dashboard` :
        // pageName=='Approval Rejected List' ? `/pages/insurance/nphies-approval-dashboard` :
        pageName=='Approval Pending List' ? `/pages/insurance/nphies-claim-dashboard/approval-pending` :
        pageName=='Approval Approved List' ? `/pages/insurance/nphies-claim-dashboard/approval-approved` :
        pageName=='Approval Rejected List' ? `/pages/insurance/nphies-claim-dashboard/approval-rejected` :
    // claim 
        pageName=='Claim Ready to Sent' ? `/pages/insurance/nphies-claim-dashboard/claim-readytosent` : // Pre auth approved list
        // pageName=='Claim Ready to Sent' ? `/pages/insurance/nphies-claim-submit` : // Pre auth approved list
        pageName=='Claim Submitted List' ? `/pages/insurance/nphies-claim-dashboard/claim-all` : // claim submitted list
        pageName=='Claim Approved List' ? `/pages/insurance/nphies-claim-dashboard/claim-approved` : // claim approved list
        pageName=='Claim Rejected List' ? `/pages/insurance/nphies-claim-dashboard/claim-rejected` : // claim rejected list
        pageName=='Claim Partial List' ? `/pages/insurance/nphies-claim-dashboard/claim-partial` : // claim parcial list
        pageName=='Claim Pended List' ? `/pages/insurance/nphies-claim-dashboard/claim-pended` : // claim pended list
        pageName=='Claim Error List' ? `/pages/insurance/nphies-claim-dashboard/claim-error` : // claim error list
        pageName=='Claim Disputed List' ? `/pages/insurance/nphies-claim-dashboard/claim-all` : // claim Disputed list


        pageName=='Billing Payments' ? `/pages/insurance/nphies-payment-reconciliation-dashboard` :
        pageName=='Billing Payments Claim' ? `/pages/insurance/nphies-payment-reconciliation-detail` :
      


        pageName=='communication Request' ? `/pages/insurance/nphies-communication-request-dashboard` :
        pageName=='communication Sent' ? `/pages/insurance/nphies-communication-list` :

        pageName=='Medication Review' ? `/pages/pharmacy/medication-review` :
        pageName=='Dispensing Work List' ? `/pages/pharmacy/salesdashboard` :
        pageName=='Completed List' ? `/pages/pharmacy/sales` :

       `/pages/reports/doctor-dashboard`; ;
      let queryParams = {};

      switch(pageName){
        case 'Ward':
          this.activeMenu='Ward';
          localStorage.setItem('activeMenu','Ward');
          route='/pages/masters/ward';
          break;

        case 'OP':
          this.activeMenu='Patient Queues';
          localStorage.setItem('activeMenu','Patient Queues');
          route='pages/patientservices/Frontdesk-Dashboard';
          break;

        case 'IP':
          this.activeMenu='Patient Queues';
          localStorage.setItem('activeMenu','Patient Queues');
          route='pages/ip/admissionList/0';
          break;

        case 'OP-Bill':
          this.activeMenu='Patient Queues';
          localStorage.setItem('activeMenu','Patient Queues');
          route='pages/patientservices/bill-list';
          break;

        case 'Pending Bill List':
          this.activeMenu='Pending Bill List';
          localStorage.setItem('activeMenu','Pending Bill List');
          break;

        case 'OP Bill List':
          this.activeMenu='OP Bill List';
          localStorage.setItem('activeMenu','OP Bill List');
          break;

        case 'IP Service':
          this.activeMenu='Patient Queues';
          localStorage.setItem('activeMenu','Patient Queues');
          route='pages/patientservices/ip-service';
          break;
          
        case 'OT':
          this.activeMenu='Patient Queues';
          localStorage.setItem('activeMenu','Patient Queues');
          route='pages/ot/booking';
          queryParams= {
            type: 'IP',
          }
          break;

        case 'DayCare': 
        this.activeMenu='Patient Queues';
        localStorage.setItem('activeMenu','Patient Queues');
        route='pages/ot/booking';
          queryParams = { type: 'DayCare'};
          break;

        case 'Shift':
          this.activeMenu='Staff Management';
          localStorage.setItem('activeMenu','Staff Management');
          route='pages/masters/shiftmst';
          break; 
          
        case 'Camp':
          this.activeMenu='Patient Queues';
          localStorage.setItem('activeMenu','Patient Queues');
          route='pages/masters/campPatientList';
          break; 

        case 'Referral':
          this.activeMenu='Patient Queues';
          localStorage.setItem('activeMenu','Patient Queues');
          route='pages/masters/referral-queue/Appointment';
          break;

        case 'Duty':
          this.activeMenu='Staff Management';
          localStorage.setItem('activeMenu','Staff Management');
          route='pages/nurse/duty-setup';
          break;  

         case 'Nurse':
          this.activeMenu='Staff Management';
          localStorage.setItem('activeMenu','Staff Management');
          route='pages/masters/employee/Nurse';
          break; 

         case 'User':
          this.activeMenu='User';
           localStorage.setItem('activeMenu','User');
           route='pages/users/userslist'; 
           break; 

        case 'Vital':
          this.activeMenu='Monitoring';
          localStorage.setItem('activeMenu','Monitoring');
          route='pages/ip/patient-monitoring';
          break;

         case 'Incident':
          this.activeMenu='Monitoring';
          localStorage.setItem('activeMenu','Monitoring');
          route='pages/nurse/patient-indent-monitoring';
          break;

         case 'Order':
          this.activeMenu='Monitoring';
          localStorage.setItem('activeMenu','Monitoring');
          route='pages/nurse/referral-queue/Nurse';
          break;

         case 'ITEMS':
          this.activeMenu='MASTER';
          localStorage.setItem('activeMenu','MASTER');
          route='pages/masters/ot-cssd-mst';
          
          break; 

          case 'COMBO SET TEMPLATE':
            this.activeMenu='MASTER';
            localStorage.setItem('activeMenu','MASTER');
            route='pages/masters/cssd-subcategory';
            
            
            break; 

          case 'CSSD Request List':
            this.activeMenu='CSSD';
            localStorage.setItem('activeMenu','CSSD');
            route='pages/ot/booking';
            break;  

            case 'CSSD Completed List':
              this.activeMenu='CSSD';
              localStorage.setItem('activeMenu','CSSD');
              route='pages/cssd/completed';
              
              break;  
              
              case 'CSSD Pickup Order List':
                this.activeMenu='CSSD';
                localStorage.setItem('activeMenu','CSSD');
                route='pages/cssd/pickup';
                
                break;  
            // Dummy Pages Starts

              case 'packing':
                  this.activeMenu='QUEUE';
                  localStorage.setItem('activeMenu','QUEUE');
                  route='pages/cssd/packing';
                  break;

              case 'sterile':
                  this.activeMenu='QUEUE';
                  localStorage.setItem('activeMenu','QUEUE');
                  route='pages/cssd/sterile';
                  break;

              case 'cssd':
                  this.activeMenu='CSSD';
                  localStorage.setItem('activeMenu','CSSD');
                  route='pages/cssd/cssd';
                  break;

              case 'cssd-dashboard':
                  this.activeMenu='CSSD';
                  localStorage.setItem('activeMenu','CSSD');
                  route='pages/cssd/cssd-dashboard';
                  break;

              case 'cleaningEntry':
                  this.activeMenu='CSSD';
                  localStorage.setItem('activeMenu','CSSD');
                  route='pages/cssd/cleaningEntry';
                  break;

              case 'cycleEntry':
                  this.activeMenu='CSSD';
                  localStorage.setItem('activeMenu','CSSD');
                  route='pages/cssd/cycleEntry';
                  break;

              case 'dataEntry':
                  this.activeMenu='CSSD';
                  localStorage.setItem('activeMenu','CSSD');
                  route='pages/cssd/dataEntry';
                  break;

              case 'cssd-openingstock':
                  this.activeMenu='STOCK';
                  localStorage.setItem('activeMenu','STOCK');
                  route='pages/cssd/cssd-openingstock';
                  break;
              case 'cssd-closingstock':
                  this.activeMenu='STOCK';
                  localStorage.setItem('activeMenu','STOCK');
                  route='pages/cssd/cssd-closingstock';
                  break;

              case 'Precleaning':
                  this.activeMenu='QUEUE';
                  localStorage.setItem('activeMenu','QUEUE');
                  route='pages/cssd/Precleaning';
                  break;

              case 'dirty-items':
                  this.activeMenu='QUEUE';
                  localStorage.setItem('activeMenu','QUEUE');
                  route='pages/cssd/dirty-items';
                  break;

              case 'cleaning':
                  this.activeMenu='QUEUE';
                  localStorage.setItem('activeMenu','QUEUE');
                  route='pages/cssd/cleaning';
                  break;

              // Dummy Pages Ends
            
            case 'Accounts':
                this.activeMenu='Accounts';
                localStorage.setItem('activeMenu','Accounts');
                
                break;  
              
              case 'Accounts Master':
                this.activeMenu='Accounts Master';
                localStorage.setItem('activeMenu','Accounts Master');
                
                break;  

              case 'Accounts Transaction':
                this.activeMenu='Accounts Transaction';
                localStorage.setItem('activeMenu','Accounts Transaction');
                
                break;
                
              case 'Accounts Report':
                this.activeMenu='Accounts Report';
                localStorage.setItem('activeMenu','Accounts Report');
                
                break;  
                case 'Cathlab List':
                this.activeMenu='CATHLABQUEUE';
                localStorage.setItem('activeMenu','CATHLABQUEUE');
                route='pages/ot/booking/cathlab';
                break;  

              // case 'Refer To Cathlab':
              //   this.activeMenu='CATHLABQUEUE';
              //   localStorage.setItem('activeMenu','CATHLABQUEUE');
              //   route='pages/shared/referToCathlab';
              //   break;
                
              case 'Cathlab Request Queue':
                this.activeMenu='CATHLABQUEUE';
                localStorage.setItem('activeMenu','CATHLABQUEUE');
                route='pages/masters/referral-queue/cathlab';
                break;  

              case 'Anesthesia':
                this.activeMenu='CATHLABQUEUE';
                localStorage.setItem('activeMenu','CATHLABQUEUE');
                route='pages/ot/AnesthesiaDashboard';
                break;  

              case 'Diet List':
              this.activeMenu='DIETQUEUE';
              localStorage.setItem('activeMenu','DIETQUEUE');
              route='pages/masters/referral-queue/diet';
              break;
              case 'Kitchen Sales':
                this.activeMenu='Kitchen Sales';
                localStorage.setItem('activeMenu','Kitchen Sales');
                route='pages/kitchen/kitchen-sales';
                break;  

              case 'Kitchen Billing':
                  this.activeMenu='Kitchen Billing';
                  localStorage.setItem('activeMenu','Kitchen Billing');
                  route='pages/kitchen/kitchen-billing';
                  break;   
              case 'Physiotherapy-WorkList':
                  this.activeMenu='physiotherapyMenu';
                  localStorage.setItem('activeMenu','physiotherapyMenu');
                  route='pages/physiotheraphy/physiotherapy-worklist';
                  break;   
                           
              case 'Beneficiary List':
                this.activeMenu='billingBeneficiary'; 
                localStorage.setItem('activeMenu','billingBeneficiary');
                
                break;  

              case 'Pre-auth Pending List':
                this.activeMenu='billingPreAuthorization'; 
                localStorage.setItem('activeMenu','billingPreAuthorization');
                
                break;  

              case 'Pre-auth Approved List':
                this.activeMenu='billingPreAuthorization'; 
                localStorage.setItem('activeMenu','billingPreAuthorization');
                
                break;  
                  
              case 'Pre-auth Rejectrd List':
                this.activeMenu='billingPreAuthorization'; 
                localStorage.setItem('activeMenu','billingPreAuthorization');
                
                break;  
                
              case 'Approval Rejected List':
                this.activeMenu='BookingApprovalQueue'; 
                localStorage.setItem('activeMenu','BookingApprovalQueue');
                
                break;

                case 'Approval Pending List':
                  this.activeMenu='BookingApprovalQueue'; 
                  localStorage.setItem('activeMenu','BookingApprovalQueue');
                  
                  break;

              case 'Approval Approved List':
                this.activeMenu='BookingApprovalQueue'; 
                localStorage.setItem('activeMenu','BookingApprovalQueue');
                
                break;    
                          
             case 'Claim Ready to Sent'  :
                this.activeMenu='BookingClaimQueue'; 
                localStorage.setItem('activeMenu','BookingClaimQueue');        
                break;
              
            case 'Claim Submitted List':   
                this.activeMenu='BookingClaimQueue'; 
                localStorage.setItem('activeMenu','BookingClaimQueue');        
                break;

            case 'Claim Approved List':
              this.activeMenu='BookingClaimQueue'; 
              localStorage.setItem('activeMenu','BookingClaimQueue');
              // route='pages/insurance/nphies-claim-dashboard/approved';
              break;   
                
            case 'Claim Rejected List':
              this.activeMenu='BookingClaimQueue'; 
              localStorage.setItem('activeMenu','BookingClaimQueue');
              // route='pages/insurance/nphies-claim-dashboard/rejected';
              break;     
              
            case 'Claim Disputed List':
              this.activeMenu='BookingClaimQueue'; 
              localStorage.setItem('activeMenu','BookingClaimQueue');
              
              break;  
                      
         case 'Billing Payments':
          this.activeMenu='Billing Payments';
          localStorage.setItem('activeMenu','Billing Payments');
          
          break;   
          case 'Communication list':
            this.activeMenu='Communication list';
            localStorage.setItem('activeMenu','Communication list');
            
            break; 

        case 'ER Patient Queue':
          this.activeMenu = 'ER Patient Queue';
          localStorage.setItem('activeMenu', 'ER Patient Queue');
          break;

        case 'Bed Management':
          this.activeMenu = 'Bed Management';
          localStorage.setItem('activeMenu', 'Bed Management');
          break;

        case 'IP Admission Request':
          this.activeMenu = 'IP Admission Request';
          localStorage.setItem('activeMenu', 'IP Admission Request');
          break; 

        case 'My WorkList':
          this.activeMenu = 'My WorkList';
          localStorage.setItem('activeMenu', 'My WorkList');
          queryParams = { page: 'WorkList' };
          break;  
        
        case 'Referral Request':
          this.activeMenu = 'Referral Request';
          localStorage.setItem('activeMenu', 'Referral Request');
          break;

        case 'ER Referral List':
          this.activeMenu = 'Patient Queues';
          localStorage.setItem('activeMenu', 'Patient Queues');
          route = '/pages/emergency/er-referral-list';
          break;
        case 'ER Registration':
          this.activeMenu = 'ER Registration';
          localStorage.setItem('activeMenu', 'ER Registration');
          break;

        case 'Medication Review':
          this.activeMenu = 'Medication Review';
          localStorage.setItem('activeMenu', 'Medication Review');
          break;

        case 'Dispensing Work List':
          this.activeMenu = 'Dispensing Work List';
          localStorage.setItem('activeMenu', 'Dispensing Work List');
          queryParams = { page: 'DispenseList' };
          break;

        case 'Completed List':
          this.activeMenu = 'Completed List';
          localStorage.setItem('activeMenu', 'Completed List');
          queryParams = { page: 'CompletedList' };
          break;

        case 'OT Request List':
          this.activeMenu = 'OT Request List';
          localStorage.setItem('activeMenu', 'OT Request List');
          route = '/pages/ot/ot-request-list';
          break;

        case 'OT Booking':
          this.activeMenu = 'OT Booking';
          localStorage.setItem('activeMenu', 'OT Booking');
          route = '/pages/ot/booking';
          break;
	  
	case 'Nurse WorkList':
          this.activeMenu = 'Nurse WorkList';
          localStorage.setItem('activeMenu', 'Nurse WorkList');
          break;

         default:
          this.activeMenu='Dashboard';
          localStorage.setItem('activeMenu','Dashboard');
          break;  

      }

      this.router.navigate([route], { queryParams });
  }

  searchCallPatient(){
    if(!!this.searchWord){   
    this.router.navigate(['/pages/patientsearch/'+this.searchWord]);
    this.searchWord=''
 }
   
  }
  searchpatient(){

    var searchData={
      "searchWord":this.searchWord,
      "fromDate": null,
      "toDate": null,
      "skip": 0,
      "take": 100
    };
    this.patRegSrvc.searchList("patientregistrationmst/" + this.tenandId + '/' + this.branchId + '/search', searchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      if(data.length>0){
        this.patientData=data;
        // this.isquicksearch=true;
      }
      // this.patRegSrvc.setPatientSearchData({searchWord:this.searchWord,datas:data});
    },
    (error) => {     
    },
    () => { 
      this.router.navigate(['/pages/patientsearch/'+this.searchWord]);
    });

    
  }
  closeQS(){
    // this.isquicksearch=false;
  }

  openBookingPopUp(){
    this.router.navigate(['/pages/patient-portal/booking-newpage/fromPortal' ]);
  }

  callLabPages(pageName: string) {
  let route = '/pages/lab/lab-dashboard';
  switch (pageName) {

    case 'Dashboard':
      this.activeMenuLab = 'Dashboard';
      route = '/pages/lab/lab-dashboard';
      break;

    case 'Order Queue':
      this.activeMenuLab = 'Order Queue';
      route = '/pages/lab/labqueue/null';
      break;

    case 'Order List':
      this.activeMenuLab = 'Order List';
      route = '/pages/lab/lab-work-order-list';
      break;

    case 'Outside Lab':
      this.activeMenuLab = 'Outside Lab';
      route = '/pages/lab/outside-lab-work-order-list';
      break;

    case 'Order Status':
      this.activeMenuLab = 'Order Status';
      route = '/pages/lab/lab-result-list';
      break;

    case 'Resampled List':
      this.activeMenuLab = 'Resampled List';
      route = '/pages/lab/lab-resampling-list';
      break;

    default:
      this.activeMenuLab = 'Dashboard';
      route = '/pages/lab/lab-dashboard';
      break;
  }

  localStorage.setItem('activeMenuLab', this.activeMenuLab);

  this.router.navigate([route]);
}

  callPharmacyPages(pageName) {
    let route;
    let queryParams = {};

    switch (pageName) {
      case 'InternalIndent':
        this.activeMenu = 'Monitoring';
        localStorage.setItem('activeMenu','Monitoring');
        route = '/pages/pharmacy/indent';
        break;

      case 'BranchIndent':
        this.activeMenu = 'Monitoring';
        localStorage.setItem('activeMenu','Monitoring');
        route = '/pages/pharmacy/indent-branch-transfer';
        break;

      case 'StockTransfer':
        this.activeMenu = 'Monitoring';
        localStorage.setItem('activeMenu','Monitoring');
        route = '/pages/pharmacy/stock-transfer';
        break;

      case 'Purchase':
        this.activeMenu = 'Purchase';
        localStorage.setItem('activeMenu','Purchase');
        route = '/pages/masters/purchase_mst';
        break;

      case 'PurchaseReturn':
        this.activeMenu = 'Purchase';
        localStorage.setItem('activeMenu','Purchase');
        route = '/pages/masters/purchase_return';
        break;

      case 'PurchaseOrder':
        this.activeMenu = 'Purchase';
        localStorage.setItem('activeMenu','Purchase');
        route = '/pages/pharmacy/po';
        break;

      case 'POTrackingList':
        this.activeMenu = 'Purchase';
        localStorage.setItem('activeMenu','Purchase');
        route = '/pages/pharmacy/po-tracking-report';
        break;

      case 'PurchaseDashboard':
        this.activeMenu = 'Purchase';
        localStorage.setItem('activeMenu','Purchase');
        route = '/pages/pharmacy/purchase-order-dashboard';
        break;

      case 'Sales':
        this.activeMenu = 'Patient Queues';
        localStorage.setItem('activeMenu','Patient Queues');
        route = '/pages/pharmacy/sales';
        break;

      case 'SalesReturn':
        this.activeMenu = 'Patient Queues';
        localStorage.setItem('activeMenu','Patient Queues');
        route = '/pages/pharmacy/salesreturn';
        break;

      case 'SalesDashboard':
        this.activeMenu = 'Patient Queues';
        localStorage.setItem('activeMenu','Patient Queues');
        route = '/pages/pharmacy/salesdashboard';
        break;

      case 'TransactionDashboard':
        this.activeMenu = 'Patient Queues';
        localStorage.setItem('activeMenu','Patient Queues');
        route = '/pages/pharmacy/transaction-dashboard';
        break;

      case 'ArchiveList':
        this.activeMenu = 'Patient Queues';
        localStorage.setItem('activeMenu','Patient Queues');
        route = '/pages/pharmacy/sales-dashboard-archive-list';
        break;

      case 'StockList':
        this.activeMenu = 'Stock';
        localStorage.setItem('activeMenu','Stock');
        route = '/pages/pharmacy/stock/stock-list';
        break;

      case 'ExpiryList':
        this.activeMenu = 'Stock';
        localStorage.setItem('activeMenu','Stock');
        route = '/pages/pharmacy/stock/stock-expiry-list';
        break;

      case 'OpeningStock':
        this.activeMenu = 'Stock';
        localStorage.setItem('activeMenu','Stock');
        route = '/pages/pharmacy/openstock';
        break;

      case 'LowStockList':
        this.activeMenu = 'Stock';
        localStorage.setItem('activeMenu','Stock');
        route = '/pages/pharmacy/lowstock';
        break;

      case 'ExcessStockList':
        this.activeMenu = 'Stock';
        localStorage.setItem('activeMenu','Stock');
        route = '/pages/pharmacy/highstock';
        break;

      case 'InternalDepStock':
        this.activeMenu = 'Stock';
        localStorage.setItem('activeMenu','Stock');
        route = '/pages/pharmacy/internal-dept-stock';
        break;

      case 'CreditBill':
        this.activeMenu = 'Accounts';
        localStorage.setItem('activeMenu','Accounts');
        route = '/pages/pharmacy/pharmacy-credit-bill';
        break;

      case 'ReceiptList':
        this.activeMenu = 'Accounts';
        localStorage.setItem('activeMenu','Accounts');
        route = '/pages/pharmacy/pharmacy-credit-bill-list';
        break;

      case 'SupplierDues':
        this.activeMenu = 'Accounts';
        localStorage.setItem('activeMenu','Accounts');
        route = '/pages/pharmacy/supplier-payment';
        break;

      case 'SupPaymentList':
        this.activeMenu = 'Accounts';
        localStorage.setItem('activeMenu','Accounts');
        route = '/pages/pharmacy/supplier-payment-list';
        break;

      case 'CreditNote':
        this.activeMenu = 'Accounts';
        localStorage.setItem('activeMenu','Accounts');
        route = '/pages/pharmacy/pharmacy-credit-notes';
        break;

      case 'PurReturnAdj':
        this.activeMenu = 'Accounts';
        localStorage.setItem('activeMenu','Accounts');
        route = '/pages/pharmacy/purchase-return-adjustment';
        break;




        
        case 'PurchaseReport':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/purchase-list';
        break;

      case 'PurRetReport':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/purchase-return-list';
        break;

      case 'ConsPurList':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/consolid-purchase-list';
        break;

      case 'SupPayReport':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/pharmacy-supplier-payment-list-report';
        break;

      case 'ReceiptReport':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/pharmacy-receipt-report';
        break;

      case 'SalesReport':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/sales-list';
        break;

      case 'SalesRetReport':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/sales-return-list';
        break;

      case 'SalesCollReport':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/sales-collection-list';
        break;

      case 'SalesRepProdWise':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/product-wise-sales';
        break;

      case 'ScheduleH':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/schedule-h';
        break;





      case 'SalesProdCon':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/sales-report';
        queryParams= {
            pageName: 'Consolidated',
        }
        break;

      case 'NReportByProd':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/sales-report';
        queryParams= {
            pageName: 'Quantity',
        }
        break;

      case 'NReportByAmount':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/sales-report';
        queryParams= {
            pageName: 'Amount',
        }
        break;

      case 'BatchSoldAndCurrent':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/batch-wise-product-sold-out-medicine';
        queryParams= {
            pageName: 'batchWiseProductSold',
        }
        break;

      case 'SoldAndCurrent':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/batch-wise-product-sold-out-medicine';
        queryParams= {
            pageName: 'productSold',
        }
        break;

      case 'MedicinePurReport':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/supplier-wise-medicine-purchase-report';
        queryParams= {
            pageName: 'supplierWise',
        }
        break;

      case 'SuPMedicineReport':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/supplier-wise-medicine-purchase-report';
        queryParams= {
            pageName: 'MedicineWise',
        }
        break;

      case 'PrchaseAnalysis':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/purchase-analysis-report';
        break;

      case 'ProdInwardAnalysis':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/product-inward-analysis-report';
        break;

      case 'SalesHSN':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/sales-hsn-report';
        break;

      case 'SalesHSNTaxUQC':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/sales-hsn-report';
        queryParams= {
            pageName: 'salesHSNWiseTaxReportwithUQC',
        }
        break;






        case 'SalesMarginDay':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/profit&Loss-Report';
        break;

      case 'SalesMarginProd':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/detailed-profit&Loss-Report';
        break;

      case 'PurAbstract':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/purchase-abstract';
        break;

        case 'PurGST':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/pharmacy-gst-report';
        break;

      case 'SalesTax':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/sales-tax-report';
        break;

      case 'PurTax':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/purchase-tax-report';
        break;

        case 'IndentReport':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/pharmacy/detailed-stock-report';
        break;

      case 'InterBranchTransfer':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/ph-branch-indent-transfer-report';
        break;

      case 'BranchRequisition':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/branch-indent-tracking-report';
        queryParams= {
            pageName: 'indentRequestOrderDeliverable',
        }
        break;

        case 'BranchDispatch':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/branch-indent-tracking-report';
        queryParams= {
            pageName: 'indentTransferOrderDeliverable',
        }
        break;






      case 'ClosingStock':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/closing-stock-report';
        break;

      case 'StockUpdate':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/stock-update-history';
        break;

        case 'StockValuation':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/pharmacy/stock/stock-list';
        queryParams= {
            from: 'reportDashboard',
        }
        break;

      case 'LocationWiseStock':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/product-wise-ph-counter-stock';
        queryParams= {
            pageName: 'counterWiseStock',
        }
        break;

      case 'WarehouseWiseStock':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/product-wise-ph-counter-stock';
        queryParams= {
            pageName: 'warehouseWiseStock',
        }
        break;

        case 'StockTransaction':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/stock-transaction';
        break;

      case 'ProductAnalysis':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/reports/product-analysis';
        break;

      case 'MedicineInventorySurplus':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/pharmacy/highstock';
        queryParams= {
            pageName: 'overallMedicineInventorySurplus',
        }
        break;

        case 'MedicineInventoryDeficit':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/pharmacy/lowstock';
        queryParams= {
            pageName: 'overallMedicineInventoryDeficit',
        }
        break;

      case 'Distributorwise':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/pharmacy/expiry-report-distributorwise';
        break;

      case 'NonMovingMedicines':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/pharmacy/non-moving-medicines';
        break;

        case 'LowStockSupplierWise':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/pharmacy/low-excess-stock-supplier-wise-report';
        queryParams= {
            pageName: 'lowStockSupplierWise',
        }
        break;

        case 'ExcessStockSupplierWise':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = '/pages/pharmacy/low-excess-stock-supplier-wise-report';
        queryParams= {
            pageName: 'excessStockSupplierWise',
        }
        break;
        case 'Viewmore':
        this.activeMenu = 'Reports';
        localStorage.setItem('activeMenu','Reports');
        route = 'pages/reports/report-dashboard';
        break;

      default:
        this.activeMenu = 'Dashboard';
        localStorage.setItem('activeMenu', 'Dashboard');
        route = '/pages/pharmacy/pharmacydashmain';
        break;
    }

    this.router.navigate([route], { queryParams });
  }

  callRadiologyPages(pageName) {
    let route;

    switch (pageName) {
      case 'RadiologyDashboard':
        this.activeMenu = 'Purchase';
        localStorage.setItem('activeMenu', 'Purchase');
        route = '/pages/radiology/radiologyqueue/XRay';
        break;

      case 'Modality':
        this.activeMenu = 'Purchase';
        localStorage.setItem('activeMenu', 'Purchase');
        route = '/pages/radiology/rad-modality';
        break;  

      case 'RadiologyOrderList':
        this.activeMenu = 'Purchase';
        localStorage.setItem('activeMenu', 'Purchase');
        route = '/pages/radiology/radiologyqueue/XRay-completed';
        break;
      case 'PACSQueue':
        this.activeMenu = 'Purchase';
        localStorage.setItem('activeMenu', 'Purchase');
        route = '/pages/radiology/pacs-queue'; 
        break;

      default:
        this.activeMenu = 'Dashboard';
        localStorage.setItem('activeMenu', 'Dashboard');
        route = '/pages/radiology/radiology-dashboard';
        break;
    }

    this.router.navigate([route]);
  }
  
  callAccountsPages(pageName) {
    let route;

    switch (pageName) {
      case 'PaymentList':
        this.activeMenu = 'Accounts';
        localStorage.setItem('activeMenu', 'Accounts');
        route = '/pages/masters/payment';
        break;

      case 'WalletTransaction':
        this.activeMenu = 'Accounts';
        localStorage.setItem('activeMenu', 'Accounts');
        route = '/pages/reports/patient-wallet-list';
        break;
      
      case 'Supplier':
        this.activeMenu = 'Accounts Master';
        localStorage.setItem('activeMenu', 'Accounts Master');
        route = '/pages/masters/supplier';
        break;

      case 'Customer':
        this.activeMenu = 'Accounts Master';
        localStorage.setItem('activeMenu', 'Accounts Master');
        route = '/pages/masters/customer-details';
        break;

      case 'Ledger':
        this.activeMenu = 'Accounts Master';
        localStorage.setItem('activeMenu', 'Accounts Master');
        route = '/pages/masters/expenses';
        break;

      case 'Bank':
        this.activeMenu = 'Accounts Master';
        localStorage.setItem('activeMenu', 'Accounts Master');
        route = '/pages/masters/bank';
        break;

      case 'Payer':
        this.activeMenu = 'Accounts Master';
        localStorage.setItem('activeMenu', 'Accounts Master');
        route = '/pages/masters/payers/fromMst';
        break;      
        
      case 'OPBillList':
        this.activeMenu = 'Accounts Transaction';
        localStorage.setItem('activeMenu', 'Accounts Transaction');
        route = '/pages/patientservices/bill-list/0';
        break;    

      case 'IPBillList':
        this.activeMenu = 'Accounts Transaction';
        localStorage.setItem('activeMenu', 'Accounts Transaction');
        route = '/pages/ip/ip-bills/0';
        break;    

      case 'AdvanceList':
        this.activeMenu = 'Accounts Transaction';
        localStorage.setItem('activeMenu', 'Accounts Transaction');
        route = '/pages/ip/advancelist';
        break;   

      case 'TrialBalance':
        this.activeMenu = 'Accounts Report';
        localStorage.setItem('activeMenu', 'Accounts Report');
        route = '/pages/ip/advancelist';
        break;

      case 'LedgerSummary':
        this.activeMenu = 'Accounts Report';
        localStorage.setItem('activeMenu', 'Accounts Report');
        route = '/pages/ip/advancelist';
        break;      
      case 'CashLedger':
        this.activeMenu = 'Accounts Report';
        localStorage.setItem('activeMenu', 'Accounts Report');
        route = '/pages/ip/advancelist';
        break;
      case 'BankLedger':
        this.activeMenu = 'Accounts Report';
        localStorage.setItem('activeMenu', 'Accounts Report');
        route = '/pages/ip/advancelist';
        break;
      case 'PaymentRegister':
        this.activeMenu = 'Accounts Report';
        localStorage.setItem('activeMenu', 'Accounts Report');
        route = '/pages/masters/payment';
        break;
      case 'ReceiptRegister':
        this.activeMenu = 'Accounts Report';
        localStorage.setItem('activeMenu', 'Accounts Report');
        route = '/pages/patientservices/credit-bill-self-list';
        break;
      case 'SalesRegister':
        this.activeMenu = 'Accounts Report';
        localStorage.setItem('activeMenu', 'Accounts Report');
        route = '/pages/pharmacy/sales';
        break;
      case 'PurchaseRegister':
        this.activeMenu = 'Accounts Report';
        localStorage.setItem('activeMenu', 'Accounts Report');
        route = '/pages/masters/purchase_mst';
        break;
      case 'JournalRegister':
        this.activeMenu = 'Accounts Report';
        localStorage.setItem('activeMenu', 'Accounts Report');
        route = '/pages/ip/advancelist';
        break;
      case 'DebitNote':
        this.activeMenu = 'Accounts Report';
        localStorage.setItem('activeMenu', 'Accounts Report');
        route = '/pages/inventory/item-debitNotes';
        break;
      case 'CreditNote':
        this.activeMenu = 'Accounts Report';
        localStorage.setItem('activeMenu', 'Accounts Report');
        route = '/pages/inventory/item-creditNotes';
        break;
      case 'BalanceSheet':
        this.activeMenu = 'Accounts Report';
        localStorage.setItem('activeMenu', 'Accounts Report');
        route = '/pages/ip/advancelist';
        break;
      case 'ProfitAndLoss':
        this.activeMenu = 'Accounts Report';
        localStorage.setItem('activeMenu', 'Accounts Report');
        route = '/pages/ip/advancelist';
        break;

        default:
        this.activeMenu = 'Dashboard';
        localStorage.setItem('activeMenu', 'Dashboard');
        route = '/pages/radiology/radiology-dashboard';
        break;
    }

    this.router.navigate([route]);
  }

   fetchJobCategory() {
    if(this.jobCategoryData?.length > 0){return;}
    this.categorySrvc.list("jobcategory").pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
     this.jobCategoryData = data?.filter(item => this.filterCategory?.includes(String(item.id)))?.map(item => ({ ...item, id: String(item.id) }));
    });
    }
   
    changejob(event){
      if(event){
      const jobCategoryId = event[0]?.data?.id;
      localStorage.removeItem("jobCategoryId");
      localStorage.setItem("jobCategoryId", jobCategoryId);
      //if(this.dropDown)  this.dropDown.close;
      this.isSaudiBranch = localStorage.getItem('LoginCountryCode') === '+966' ? true : false;
      if (this.isSaudiBranch) {
        let routingUrl = localStorage.getItem('landingPageUrl');
        return this.router.navigateByUrl(routingUrl);
      } else {
      if( jobCategoryId==25){
        return this.router.navigateByUrl("pages/nurse/nurse-manager-dashboard");
      }
      else if(jobCategoryId==2){
        return this.router.navigateByUrl("pages/nurse/nurse-dashboard");
      }
      else if(jobCategoryId==5){
        return this.router.navigateByUrl("pages/lab/lab-dashboard");
      }
      else if(jobCategoryId==4){
        return this.router.navigateByUrl("pages/pharmacy/pharmacydashmain");
      }
      else if(jobCategoryId==21){
        return this.router.navigateByUrl("pages/radiology/radiology-dashboard");
      }
      }
    }

    }
}
